import styled from 'styled-components';
import { ScStepsByGroupCard } from '@/modules/restrictions/components/StepsByGroup/styled';
import { ScContainer } from '@/styles/common';
import { device } from '@/styles/helpers';

export const ScBonanzaPromoPage = styled.div`
  ${ScContainer} {
    & .wrapper-lobby-btn {
      display: none;
      @media (${device.mobile}) {
        display: block;
      }
    }
  }
  .radius-decor {
    border-radius: 24px 24px 0 0;
    margin-top: -24px;
    display: flex;
    padding-top: 64px;
    background-color: ${({ theme }) => theme.blackColor};

    & > div {
      display: flex;
      flex-direction: column;
      gap: 64px;
      align-items: center;
    }

    @media (${device.mobile}) {
      padding-top: 32px;
    }
  }

  ${ScStepsByGroupCard} {
    > img {
      object-fit: contain;
    }
  }

  .content {
    display: grid;
    gap: 64px;
    margin-top: 80px;
    @media (${device.mobile}) {
      margin-top: 32px;
    }
    & > div {
      margin-top: 0px;
    }
  }

  .lobbyButton {
    margin-top: 32px;
  }
`;
